(function () {
  /* ---------- 1. Product gallery: shade groups, swipe, dots, thumbnails ---------- */
  function buildGallery() {
    var dataEl = document.querySelector('#MainContent .af-gallery-data') || document.querySelector('.af-gallery-data');
    if (!dataEl) return;
    var product = dataEl.closest('.main-product');
    if (!product || product.closest('.quickview-product, .modal, .offcanvas')) return;
    var mediaCol = product.querySelector('.product__media');
    if (!mediaCol || mediaCol.querySelector('.af-gallery')) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var all = data.media || [];
    if (!all.length) return;
    var variants = data.variants || {};

    /* Group images by shade: a shade's image + every image after it until the next shade's image */
    var indexById = {};
    all.forEach(function (m, i) { indexById[String(m.id)] = i; });
    var starts = [];
    Object.keys(variants).forEach(function (vid) {
      var idx = indexById[String(variants[vid])];
      if (idx !== undefined && starts.indexOf(idx) === -1) starts.push(idx);
    });
    starts.sort(function (a, b) { return a - b; });
    var grouped = starts.length > 1;
    var shared = grouped ? all.slice(0, starts[0]) : [];
    function groupFor(vid) {
      var idx = indexById[String(variants[vid])];
      if (!grouped || idx === undefined) return null;
      var pos = starts.indexOf(idx);
      var end = pos < starts.length - 1 ? starts[pos + 1] : all.length;
      return all.slice(idx, end);
    }

    var gal = document.createElement('div');
    gal.className = 'af-gallery';
    var stage = document.createElement('div');
    stage.className = 'af-gallery__stage';
    var track = document.createElement('div');
    track.className = 'af-gallery__track';
    var dots = document.createElement('div');
    dots.className = 'af-gallery__dots';
    var thumbs = document.createElement('div');
    thumbs.className = 'af-gallery__thumbs';
    stage.appendChild(track);
    stage.appendChild(dots);
    gal.appendChild(stage);
    gal.appendChild(thumbs);

    var list = [];

    function render(items) {
      list = items;
      track.innerHTML = ''; dots.innerHTML = ''; thumbs.innerHTML = '';
      items.forEach(function (m, i) {
        var slide = document.createElement('div');
        slide.className = 'af-gallery__slide';
        if (m.video) {
          var v = document.createElement('video');
          v.src = m.video; v.poster = m.src; v.muted = true; v.loop = true; v.controls = true;
          v.setAttribute('playsinline', '');
          slide.appendChild(v);
        } else {
          var img = document.createElement('img');
          img.src = m.src;
          if (m.srcSm) img.srcset = m.srcSm + ' 800w, ' + m.src + ' 1400w';
          img.sizes = '(min-width: 992px) 50vw, 100vw';
          img.alt = m.alt || '';
          img.loading = i === 0 ? 'eager' : 'lazy';
          img.draggable = false;
          slide.appendChild(img);
        }
        track.appendChild(slide);

        if (items.length > 1) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'af-gallery__dot' + (i === 0 ? ' is-active' : '');
          d.setAttribute('aria-label', 'Image ' + (i + 1));
          d.addEventListener('click', function () { goTo(i); });
          dots.appendChild(d);

          var t = document.createElement('button');
          t.type = 'button';
          t.className = 'af-gallery__thumb' + (i === 0 ? ' is-active' : '');
          t.setAttribute('aria-label', 'Show image ' + (i + 1));
          var ti = document.createElement('img');
          ti.src = m.thumb || m.srcSm || m.src; ti.alt = ''; ti.loading = 'lazy'; ti.draggable = false;
          t.appendChild(ti);
          t.addEventListener('click', function () { goTo(i); });
          thumbs.appendChild(t);
        }
      });
      dots.style.display = items.length > 1 ? '' : 'none';
      thumbs.style.display = items.length > 1 ? '' : 'none';
      track.scrollLeft = 0;
    }

    function goTo(i, instant) {
      track.scrollTo({ left: track.clientWidth * i, behavior: instant ? 'auto' : 'smooth' });
    }
    function current() { return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)); }
    function markActive() {
      var idx = current();
      Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-active', i === idx); });
      Array.prototype.forEach.call(thumbs.children, function (t, i) {
        t.classList.toggle('is-active', i === idx);
        if (i === idx) {
          var l = t.offsetLeft - thumbs.clientWidth / 2 + t.clientWidth / 2;
          thumbs.scrollTo({ left: l, behavior: 'smooth' });
        }
      });
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(markActive); }, { passive: true });

    /* Mouse drag on desktop (touch uses native swipe) */
    var down = false, startX = 0, startLeft = 0, dragged = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; dragged = false; startX = e.clientX; startLeft = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 5) dragged = true;
      track.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function (e) {
      if (!down) return;
      down = false;
      track.classList.remove('is-dragging');
      var dx = e.clientX - startX;
      var idx = Math.round(startLeft / Math.max(track.clientWidth, 1));
      if (dx < -50) idx++; else if (dx > 50) idx--;
      idx = Math.max(0, Math.min(list.length - 1, idx));
      goTo(idx);
    });
    track.addEventListener('click', function (e) { if (dragged) { e.preventDefault(); e.stopPropagation(); } }, true);

    /* Which shade is selected? */
    var root = product.closest('main-product') || product;
    function selectedVariant() {
      var sel = product.querySelector('select.variant-select, select[name="id"]');
      return (sel && sel.value) || new URLSearchParams(window.location.search).get('variant') || root.getAttribute('data-variantid');
    }

    var urlVariant = new URLSearchParams(window.location.search).get('variant');
    var lastVariant = selectedVariant();
    var first = groupFor(lastVariant);
    if (first && !urlVariant) {
      render(shared.concat(first));
    } else if (first) {
      render(first);
    } else {
      render(all);
    }

    mediaCol.insertBefore(gal, mediaCol.firstChild);
    mediaCol.classList.add('af-gallery-on');

    function sync() {
      if (!document.body.contains(gal)) return;
      var v = selectedVariant();
      if (!v || String(v) === String(lastVariant)) return;
      lastVariant = v;
      var g = groupFor(v);
      if (g) {
        render(g);
      } else {
        var idx = indexById[String(variants[v])];
        if (idx !== undefined) {
          var pos = list.indexOf(all[idx]);
          if (pos > -1) goTo(pos);
        }
      }
    }
    setInterval(sync, 300);
    product.addEventListener('click', function (e) {
      if (e.target.closest('.variants, .variants_container, .option-item, select')) setTimeout(sync, 120);
    });
    product.addEventListener('change', function () { setTimeout(sync, 120); });
  }

  /* ---------- 2. Tap anywhere on a product image to open the product ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('a, button, input, select, textarea, label, summary, video, [role="button"]')) return;
    if (t.closest('.main-product, #mainProduct, .product__media, .quickview-product, .modal, .offcanvas, .af-gallery')) return;
    var isImage = t.tagName === 'IMG' || t.closest('picture, [class*="image"], [class*="img"], [class*="media"]');
    if (!isImage) return;

    var node = t, link = null;
    for (var i = 0; i < 6 && node && node !== document.body; i++) {
      node = node.parentElement;
      if (!node) break;
      var links = node.querySelectorAll('a[href*="/products/"]');
      if (links.length) {
        var firstHref = links[0].getAttribute('href').split('?')[0].split('#')[0];
        var same = Array.prototype.every.call(links, function (a) {
          return a.getAttribute('href').split('?')[0].split('#')[0] === firstHref;
        });
        if (same) link = links[0];
        break;
      }
    }
    if (link) window.location.href = link.href;
  });

  function init() { buildGallery(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  setInterval(buildGallery, 800);
  document.addEventListener('shopify:section:load', init);
})();
